import { DateTime } from "luxon";
import React from "react";

export const formatDate = (
  date,
  format = DateTime.DATETIME_MED,
  options = { includeTime: true }
) => {
  if (!date) return "";

  if (!options?.includeTime) {
    return DateTime.fromISO(date).toLocaleString(format || DateTime.DATE_SHORT);
  }

  return DateTime.fromISO(date).toLocaleString(format);
};

export const convertDate = (date, options = { isForEditMode: false }) => {
  if (!date) return "";

  if (options.isForEditMode) {
    return DateTime.fromISO(date).toISODate();
  } else {
    return DateTime.fromISO(date).toLocaleString(DateTime.DATETIME_SHORT);
  }
};

const localizeDateFull = (date) =>
  DateTime.fromISO(date).toLocaleString(DateTime.DATE_FULL);

const localizeDateMed = (date) =>
  DateTime.fromISO(date).toLocaleString(DateTime.DATE_MED);

const localizeDateShort = (date) =>
  DateTime.fromISO(date).toLocaleString(DateTime.DATE_SHORT);

const localizeTimeFull = (date) =>
  DateTime.fromISO(date).toLocaleString(DateTime.TIME_WITH_SECONDS);

const localizeTimeShort = (date) =>
  DateTime.fromISO(date).toLocaleString(DateTime.TIME_SIMPLE);

const localizeDateTimeMed = (date) =>
  DateTime.fromISO(date).toLocaleString(DateTime.DATETIME_MED);

const localizeDateTimeSeconds = (date) =>
  DateTime.fromISO(date).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS);

const localizeDateTimeShort = (date) =>
  DateTime.fromISO(date).toLocaleString(DateTime.DATETIME_SHORT);

const toISODate = (date) => DateTime.fromISO(date).toISODate();

const fromJSToISODate = (date) => DateTime.fromJSDate(date).toISODate();

const humanizeDate = (date) => DateTime.fromISO(date).toRelative(date);

const getDateTimeAuto = () => {
  const now = new Date();
  now.setMinutes(now.getMinutes() + 345);
  return now.toISOString().slice(0, 16);
};

export const useDynamicNepaliTime = () => {
  const [nepaliTime, setNepaliTime] = React.useState(getDateTimeAuto());

  React.useEffect(() => {
    const interval = setInterval(() => {
      setNepaliTime(getDateTimeAuto());
    }, 60000); // 1 minute interval for time update

    return () => clearInterval(interval);
  }, []);

  return nepaliTime;
};

export {
  localizeDateFull,
  localizeDateMed,
  localizeDateShort,
  localizeTimeFull,
  localizeTimeShort,
  localizeDateTimeMed,
  localizeDateTimeSeconds,
  localizeDateTimeShort,
  toISODate,
  fromJSToISODate,
  humanizeDate,
  getDateTimeAuto,
};
